<template>
  <div :class="this.acMode ? 'raceFiltersAcMode' : 'stdMode'">
    <template>
      <v-btn outlined color="white" x-small class="ma-1 float-left raceFiltersMenuButton" @click.stop="dialog = true" style="overflow: auto; margin: 2px !important;">
        Race Filters
      </v-btn>
    </template>
    <v-dialog v-model="dialog" max-width="600" :overlay-opacity="opacity" retain-focus>
      <v-card style="max-width:600px;">
        <v-card-title style="background: #425058;" class="white--text">
          <div style="width:100%">
            <div class="float-left">
              <span class="headline">Schedule Filters</span>
              <v-list-item-subtitle>Customize the schedule to view specific races</v-list-item-subtitle>
            </div>
            <v-btn class="float-right" icon small @click.stop="dialog = false" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-container fluid>
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header :class="this.acMode ? 'raceFiltersAcMode' : 'stdMode'">Countries</v-expansion-panel-header>
              <v-expansion-panel-content>
                <Countries :acMode="this.acMode" :countries="getIsCountrySelectedFilter" :onClick="onCountryClick" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-5"></v-spacer>
          <v-spacer class="mt-5"></v-spacer>
          <div style="float:left;width:250px;margin-right:20px;">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="codesPanel" :class="this.acMode ? 'raceFiltersAcMode' : 'stdMode'">Codes</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <Codes :acMode="this.acMode" :codes="getIsCodesSelectedFilter" :onClick="onCodesClick" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div style="clear:both"></div>
          <v-spacer class="mt-5"></v-spacer>
          <v-card-title class="grey darken-1 white--text speedMap-footer pt-3">
            <v-btn small @click="resetToDefault" :color="!resetConfirm ? '' : 'error'"><v-icon class="mr-2">mdi-refresh</v-icon>{{ !resetConfirm ? 'Reset to Default' : 'Are you sure? Click to reset'}}</v-btn>
        </v-card-title>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Countries from './filters/Countries'
import Codes from './filters/Codes'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  data: () => ({
    panel: 0,
    opacity: 0.02,
    dialog: false,
    resetConfirm: false
  }),
  props: {
    setFiltersOpen: Function
  },
  components: {
    Countries,
    Codes
  },
  watch: {
    dialog: function (d) {
      if (d) {
        this.setFiltersOpen(d)
      } else {
        this.setFiltersOpen(d)
      }
    }
  },
  computed: {
    ...mapState(['acMode']),
    ...mapGetters(['getIsCountrySelectedFilter', 'getIsCodesSelectedFilter', 'getMeetingTypesSelectedFilter', 'getStatusesFilter', 'getStartersFilter', 'getDistanceFilter', 'getConditionsFilter'])
  },
  methods: {
    ...mapActions(['updateRaceNavFilter', 'resetRaceFilters']),
    onCountryClick (countries) {
      this.updateRaceNavFilter({ filter: 'countries', value: countries })
    },
    onCodesClick (codes) {
      this.updateRaceNavFilter({ filter: 'codes', value: codes })
    },
    resetToDefault: function () {
      if (this.resetConfirm) {
        this.resetRaceFilters()
      }
      this.resetConfirm = !this.resetConfirm
      if (this.resetConfirm) {
        setTimeout(() => { this.resetConfirm = false }, 5000)
      }
    }
  }
}
</script>

<style>
.raceFiltersAcMode {
  font-weight:bold !important
}
</style>
